import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Header6 from '../../components/header6/Header6';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/Help-Desk-Components/Footer/Footer';

const PrivacyPage = () => {
    return (
        <Fragment>
            <div className='help_desk'>
                <Header6 />

                {/* Page Header */}
                <section style={{
                    background: 'linear-gradient(135deg, #4b5563 0%, #374151 50%, #1f2937 100%)',
                    paddingTop: '140px',
                    paddingBottom: '80px',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    {/* Decorative elements */}
                    <div style={{
                        position: 'absolute',
                        top: '-100px',
                        right: '-100px',
                        width: '300px',
                        height: '300px',
                        background: 'radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, transparent 70%)',
                        borderRadius: '50%',
                        pointerEvents: 'none'
                    }}></div>

                    <div className="container">
                        <div style={{ maxWidth: '800px' }}>
                            <span className="section-badge" style={{
                                background: 'rgba(59, 130, 246, 0.15)',
                                borderColor: 'rgba(59, 130, 246, 0.3)',
                                color: '#93c5fd',
                                marginBottom: '20px',
                                display: 'inline-flex'
                            }}>
                                Legal
                            </span>
                            <h1 style={{
                                fontSize: '3rem',
                                fontWeight: '800',
                                color: 'white',
                                marginBottom: '16px',
                                lineHeight: '1.2'
                            }}>
                                Privacy Policy
                            </h1>
                            <p style={{
                                fontSize: '1.125rem',
                                color: 'rgba(255, 255, 255, 0.7)',
                                marginBottom: '8px'
                            }}>
                                Your privacy is important to us. Learn how we collect, use, and protect your data.
                            </p>
                            <span style={{
                                fontSize: '0.875rem',
                                color: 'rgba(255, 255, 255, 0.5)'
                            }}>
                                Last updated: February 2nd, 2026
                            </span>
                        </div>
                    </div>
                </section>

                {/* Content Section */}
                <section style={{
                    background: '#ffffff',
                    padding: '80px 0'
                }}>
                    <div className="container">
                        <div style={{ maxWidth: '800px', margin: '0 auto' }}>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Data Controller and Data Collection</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
                                    SaaS Watch is committed to safeguarding your privacy. The types of Personal Data collected may vary depending on the services offered and may be voluntarily provided by users or automatically collected when using this site.
                                </p>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    This data may include but is not limited to user-provided information, cookies, and other tracking tools. Cookies are used solely to improve the user experience and personalize service offerings.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>User Responsibilities</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    Users are responsible for any third-party data shared via the SaaS Watch website and affirm their rights to communicate such data, thereby relieving SaaS Watch of any associated liability.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Data Processing and Security</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    Data is processed using secure IT systems at SaaS Watch's operational offices and in other locations necessary to support our services. SaaS Watch ensures strict security measures to prevent unauthorized access, modification, or destruction of personal data.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Data Storage and Retention</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    Personal data is retained only for as long as necessary to fulfill the intended purpose or as required by law. Users may request data deletion or suspension at any time by contacting SaaS Watch.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Legal Action</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    SaaS Watch may disclose personal data to comply with legal obligations or respond to public authority requests. Personal data may also be used in legal proceedings arising from improper use of the website or services.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>User Rights</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
                                    Users have the right to access, update, or delete their personal data and may contact SaaS Watch at any time for assistance. Users can also request data anonymization or oppose processing activities under applicable laws.
                                </p>
                                <ul style={{
                                    listStyle: 'none',
                                    padding: 0,
                                    margin: 0
                                }}>
                                    {[
                                        'Request information about the personal data we hold',
                                        'Correct any inaccurate or incomplete data',
                                        'Request deletion of data when no longer needed',
                                        'Request data in a transferable format',
                                        'Limit the processing of data in certain situations',
                                        'Object to processing for direct marketing',
                                        'Withdraw consent for data processing at any time',
                                        'File a complaint with a supervisory authority'
                                    ].map((item, index) => (
                                        <li key={index} style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '12px',
                                            marginBottom: '12px',
                                            color: '#4b5563'
                                        }}>
                                            <span style={{
                                                width: '20px',
                                                height: '20px',
                                                background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0,
                                                marginTop: '2px'
                                            }}>
                                                <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                                                    <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </span>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>"Do Not Track" Requests</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    SaaS Watch does not currently support "Do Not Track" requests. For information on how third-party services handle such requests, please refer to their respective privacy policies.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Policy Updates</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    SaaS Watch may update this Privacy Policy periodically. Users are encouraged to review this page regularly. Continued use of the website constitutes acceptance of these terms.
                                </p>
                            </div>

                            <div style={{
                                background: '#f3f4f6',
                                borderRadius: '16px',
                                padding: '32px',
                                marginTop: '48px'
                            }}>
                                <h2 style={{
                                    fontSize: '1.25rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '12px'
                                }}>Questions?</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    If you have any questions about this Privacy Policy, please <Link to="/#contact" style={{ color: '#3b82f6', textDecoration: 'underline' }}>contact us</Link>.
                                </p>
                            </div>

                        </div>
                    </div>
                </section>

                <Scrollbar />
            </div>
            <Footer />
        </Fragment>
    )
};

export default PrivacyPage;
